<template>
  <div class="sidebar">
    <div class="logo-wrapper">
      <img :src="arcaneLogo" alt="Arcane Logo" class="logo" />
    </div>
    <div class="select">
      <OrganizationSelect />
    </div>
  </div>
</template>

<script>
import OrganizationSelect from '~/components/account/OrganizationSelect';
import arcaneLogo from '~/assets/svg/Arcane-logo.svg';

export default {
  name: 'SideNavigation',

  components: {
    OrganizationSelect,
  },
  setup() {
    return { arcaneLogo };
  },
};
</script>

<style scoped lang="scss">
.sidebar {
  display: flex;
  flex-direction: column;
  background: $bb-neutral-6;
  width: 248px;
  height: 100vh;
  padding: 0;
  overflow-y: scroll;

  .select {
    margin-top: auto;
  }

  .logo-wrapper {
    margin-top: $bb-spacing-4;
    margin-left: $bb-spacing-5;

    .logo {
      height: 38px;
      cursor: pointer;
    }
  }
}
</style>
